export default __webpack_public_path__ + "static/media/pulse.c7976023.less";